import React, { Component } from 'react';

import appSettings from '../../config/settings';
import * as log from '../../util/log';

import { LoadableComponentErrorBoundaryPage } from './LoadableComponentErrorBoundaryPage';

// Use ErrorBoyndary to catch ChunkLoadError
// https://reactjs.org/docs/error-boundaries.html
class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error, info) {
    // Any render error reaching this boundary would otherwise unmount the
    // whole tree and leave a blank page, which is what the client saw on
    // "Finish and review" (2026-09-11) — a bug that produced no report anyone
    // could act on. Logged (Sentry when configured, console otherwise) and
    // rendered as a page, so the next one arrives with an error code attached.
    log.error(error, 'render-error', { componentStack: info?.componentStack });
  }

  render() {
    if (this.state.error) {
      return (
        <LoadableComponentErrorBoundaryPage
          isChunkLoadError={this.state.error.name === 'ChunkLoadError'}
        />
      );
    }

    return this.props.children;
  }
}

// LoadableComponentErrorBoundary helps in situations
// where production build changes in the server and
// long-living client app tries to fetch code chunks that don't exist anymore.
// Note: in development mode with Hot Module Reloading (HMR) in use, this causes error loops.
const UseLoadableErrorBoundaryOnlyInProdutionMode = props => {
  const { children } = props;
  return appSettings.dev ? (
    children
  ) : (
    <LoadableComponentErrorBoundary>{children}</LoadableComponentErrorBoundary>
  );
};
export default UseLoadableErrorBoundaryOnlyInProdutionMode;
